export function switchColors() {
  const newModelsColors = document.querySelectorAll('.new-models-colors');
  let injectStyle = document.createElement("style");
  let baseColors = '';
  let carsInternalColors = '';

  newModelsColors.forEach((car) => {
    let carId = car.getAttribute("data-car-id");
    let color = car.getAttribute("data-color");

    if (color) {
      baseColors = `
        .car-${carId}::before {
          background-color: ${color};
        }
      `;
    }

    injectStyle.innerHTML += carsInternalColors;
    injectStyle.innerHTML += baseColors;
    document.head.appendChild(injectStyle);
  });
}
